<script lang="ts">
	import queryString from "query-string";
	import { navigate } from "svelte-routing";

	import { t, auth } from "../stores";
	import LoadingLayout from "../layouts/LoadingLayout.svelte";

	const navigateTo = `${"HITIT_BACKEND_URL"}oauth/authorize?response_type=code&client_id=web&redirect_uri=${"HITIT_HUB_URL"}login&scope=CLIENT`;

	let error: string | undefined;
	let parsed: ReturnType<typeof queryString.parse> = {};
	let code: string | undefined;

	// API 중복 호출 방지 플래그 (500 에러 방어)
  let isRequesting = false;

	if (window) parsed = queryString.parse(window.location.search);
	if (typeof parsed["code"] === "string") {
		code = parsed["code"];
	}

	if (!code) {
		error = $t("hub.login.error.bad_approach");
	} else if (!isRequesting){
		isRequesting = true;

		$auth
      .grantCode(code)
      .then(() => navigate("/"))
      .catch(() => {
        error = $t("hub.login.error.login_failed");
        isRequesting = false; 
      });
	}
</script>

<LoadingLayout
	error={error}
	errorAction={$t("hub.login.redirect")}
	on:click={() => navigate(navigateTo)}
/>
